import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AppService } from '../app.service';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private appservice: AppService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.redirectAuthenticatedUser();
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.redirectAuthenticatedUser();
  }

  private redirectAuthenticatedUser(): boolean | UrlTree {
    if (this.appservice.Current_User?.UM_Company || this.appservice.getData()) {
      return this.router.createUrlTree([this.appservice.Lab_Home_Page || '/dashboard/default']);
    }

    return true;
  }
}
